import { Box, Card, Divider, Stack, useMediaQuery } from '@mui/material';

import { ProfileApi } from 'enrollment/features/ProfileEdit/ManageProfile/ProfileApi';
import './enrollmentCard.css';

export interface CardProps {
  textAlign?: string;
  children?: JSX.Element | JSX.Element[];
  navigateTo?: string;
}

export const EnrollmentCard = ({
  textAlign = 'center',
  children,
  navigateTo,
}: CardProps) => {
  const orientationDivider = useMediaQuery('(max-width: 1199px)')
    ? 'horizontal'
    : 'vertical';

  const stackDirection = useMediaQuery('(max-width: 1199px)')
    ? 'column'
    : 'row';

  return (
    <>
      <Card sx={{ textAlign: textAlign }} className="profile-container">
        <Box>
          <Stack
            flexDirection={stackDirection}
            flexGrow={1}
            divider={<Divider orientation={orientationDivider} flexItem />}
          >
            {children}
          </Stack>
        </Box>
      </Card>
      <ProfileApi navigateTo={navigateTo} />
    </>
  );
};
